module.exports = __webpack_public_path__ + "img/12.c80f8647.png";